import React from 'react';

import { NavLink } from 'react-router-dom';

import './BottomNavigation.scoped.scss';

interface Props {
  icon?: React.ReactNode;
  path?: string;
  name?: string;
}

const BottomNavigationItem: React.FC<Props> = ({ icon, name, path }) => {
  return (
    <div className="bottom-navigation-item pointer">
      <NavLink exact={path === '/'} className="option" activeClassName="active" to={path}>
        <>
          {icon}
          <span>{name}</span>
        </>
      </NavLink>
    </div>
  );
};

export default BottomNavigationItem;
